import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors, helpers } from "@clockwise/web-commons/src/styles/color.styles";

const calloutContainer: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginBottom: 15,
};

const calloutIcon: CSSProperties = {
  color: colors.yellow.darker,
  marginRight: 10,
};

const calloutLabel: CSSProperties = {
  flexGrow: 1,
};

const manageBtn: CSSProperties = {
  color: colors.yellow.standard,
  "&:hover": {
    backgroundColor: helpers.lighten(colors.yellow.standard, 0.75),
  },
};

export const styles = {
  calloutContainer,
  calloutIcon,
  calloutLabel,
  manageBtn,
};
